import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import * as S from "./ModalShareAccessToPatient.style";
import * as P from "../../../../../utils/pipes";

// Hooks
import ZaiaReaction from "../../../../zaiaComponents/zaiaReaction";
import ZaiaButton from "../../../../zaiaComponents/zaiaButton";
import ZaiaModalResponseContent from "../../../../zaiaComponents/zaiaModalResponseContent";
import ZaiaInput from "../../../../zaiaComponents/zaiaInput";
import ZaiaRoundInput from "../../../../zaiaComponents/zaiaRoundInput";
import { QUERY_GET_USERS } from "../../../../../graphql/queries/User";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import ZaiaImage from "../../../../zaiaComponents/zaiaImage";
import Popup from "reactjs-popup";
import ProcessName from "../../../shared/processName";
import { QUERY_GET_DOCTORS_DATA } from "../../../../../graphql/queries/Doctor";
import useDoctorData from "../../../../../hooks/useDoctorData";
import { MUTATION_INSERT_ROLE_AND_DOCTOR_TO_PROCESS_ROLE, MUTATION_INSERT_DOCTOR_TO_PROCESS_ROLE, MUTATION_DELETE_DOCTOR_TO_PROCESS_ROLE_BY_IDS } from "../../../../../graphql/mutations/Doctor";
import { QUERY_GET_PROCESS_ROLES_BY_ID } from "../../../../../graphql/queries/Process";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import DoctorItem from "./doctorItem";
import { GET_DOCTOR_TO_PROCESS_ROLE } from "../../../../../graphql/queries/DoctorToProcessRole";
import FlorenzButton from "../../../../florenzComponents/florenzButton";


// Assets
const eventsCalendarEmpty = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/no-results.svg`;
const logoZaiaLoading = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/singularity-health-loader.svg`;
const logoZaiaAlert = `${process.env.REACT_APP_STORAGE_ZAIA_RESOURCES}/zaiaReactions/reaction-error-data.svg`;

function ModalShareAccessToPatient({
  patientInfo,
  setModalActive
}) {

  const { t, i18n: { language } } = useTranslation("global");
  const {doctorData} = useDoctorData();

  const [currentDoctors, setCurrentDoctors] = useState([]);
  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [doctorsToAdd, setDoctorsToAdd] = useState([]);
  const [doctorsToRemove, setDoctorsToRemove] = useState([]);

  const { 
    data: doctorsData,
    loading: loadingDoctorsData,
    error: errorDoctorsData,
    refetch: refetchDoctorsData
  } = useQuery(
    QUERY_GET_DOCTORS_DATA,
    {
      variables: {
        doctorId: doctorData?.id,
        processId: patientInfo?.process?.id
      }
    }
  );


  const [insertDoctorToProcessRole, { loading: insertDoctorToProcessRoleLoading }] = useMutation(MUTATION_INSERT_DOCTOR_TO_PROCESS_ROLE);
  const [insertRoleAndDoctorToProcessRole, { loading: insertRoleAndDoctorToProcessRoleLoading }] = useMutation(MUTATION_INSERT_ROLE_AND_DOCTOR_TO_PROCESS_ROLE);
  const [deleteDoctorToProcessRole, { loading: deleteDoctorToProcessRoleLoading }] = useMutation(MUTATION_DELETE_DOCTOR_TO_PROCESS_ROLE_BY_IDS);  
  
  const { data: doctorToProcessRoleData, loading: doctorToProcessRoleLoading, error: doctorToProcessRoleError,refetch: refetchDoctorToProcessRoleData } = useQuery(GET_DOCTOR_TO_PROCESS_ROLE,
    {
      variables: {
        userToProcessId: patientInfo.id
      }
    }
  );
  const [ getProcessRoleData ] = useLazyQuery(QUERY_GET_PROCESS_ROLES_BY_ID);

  useEffect(() => {
    refetchDoctorToProcessRoleData();
    refetchDoctorsData();
  }, []);  

  useEffect(() => {        
    const currentDoctorsTemp = doctorToProcessRoleData?.doctorToProcessRole.map(doctorToProcessRole => {

      const doctorDataTemp = doctorsData?.health_system_colleagues_by_process.health_system_colleagues[0].doctors.find(doctor => doctor.id === doctorToProcessRole.doctorId);

      return {
        id: doctorToProcessRole.id,
        name: `${doctorDataTemp?.name} ${doctorDataTemp?.lastname}`,
        value: doctorToProcessRole.doctorId
      };
    });
    setCurrentDoctors(currentDoctorsTemp || []);

    const availableDoctorsTemp = doctorsData?.health_system_colleagues_by_process.health_system_colleagues[0].doctors.filter((doctor) => !currentDoctorsTemp?.some(current => current.value === doctor.id)).map(doctor => {
      return {
        id: null,
        name: `${doctor.name} ${doctor.lastname}`,
        value: doctor.id
      };
    });
    setAvailableDoctors(availableDoctorsTemp || []);

  }, [doctorsData]);
  

  const { 
    data: patientsData,
    loading: loadingPatientsData,
    error: errorPatientsData,
  } = useQuery(
    QUERY_GET_USERS
  );


  const [formSuccess, setFormSuccess] = useState(null); 
  const [inputText, setInputText] = useState(''); 

  const getFilterText = (text) => {
    return inputText 
      ? String(P.removeAccent(text)).toLowerCase().includes(P.removeAccent(inputText).toLowerCase())
      : true
  }

  const handleRemoveDoctors = async () => {

    console.log("moster MF REMOVE", doctorsToRemove);

    try {
      await deleteDoctorToProcessRole({
        variables: {
          doctorToProcessRoleIds: doctorsToRemove,
        },
      });
      setFormSuccess(true);
    } catch (err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  const handleSubmit = () => {
    console.log("moster MF", doctorsToAdd);
    console.log("moster MF REMOVE", doctorsToRemove);

    if(doctorsToAdd.length > 0) {
      handleAddDoctors();
    }

    if(doctorsToRemove.length > 0) {
      handleRemoveDoctors();
    }
  }

  const handleAddDoctors = async () => {    
    try {
      const { data } = await getProcessRoleData(
        {
          variables: {
            processId: patientInfo.process.id,
            roleId: "medical_staff"
          }
        }
      )

      if(data.processRole.length === 0) {
        await insertRoleAndDoctorToProcessRole({
          variables: {
            id: "medical_staff",
            processId: patientInfo.processId,
            roleName: { "en": "medical staff", "es": "personal médico" },
            doctorToProcessRoles: { data: doctorsToAdd.map((doctor) => {
                return {
                  doctorId: doctor.doctorId, 
                  userToProcessId: doctor.userToProcessId, 
                }
              })
            }},
        });
      } else {
        await insertDoctorToProcessRole({
          variables: {
            doctorsInfo: doctorsToAdd.map((doctor) => {
              return {
                doctorId: doctor.doctorId, 
                processId: doctor.processId,
                userToProcessId: doctor.userToProcessId, 
                roleId: "medical_staff"
              }
            })
          },
        });
      }
      setFormSuccess(true);
    } catch(err) {
      console.log(err);
      setFormSuccess(false);
    }
  }

  useEffect(() => {    

    const doctorToAddTemp = currentDoctors.filter(doctor => {

      return !doctorToProcessRoleData?.doctorToProcessRole?.some(d => d.doctorId === doctor.value);
    }).map(doctor => {
      return {
        doctorId: doctor.value,
        processId: patientInfo?.processId,
        userToProcessId: patientInfo?.id,
        roleId: "medical_staff"
      }
    });        

    setDoctorsToAdd(doctorToAddTemp || []);
  }, [availableDoctors]);

  useEffect(() => {
    const doctorsToRemoveTemp = doctorToProcessRoleData?.doctorToProcessRole.filter(doctorToProcessRole => {
      return !currentDoctors.some(current => current.value === doctorToProcessRole.doctorId)
    }).map(doctorToProcessRole => doctorToProcessRole.id);

    setDoctorsToRemove(doctorsToRemoveTemp || []);
  }, [currentDoctors]);

  const handleRemoveDoctor = (doctor) => {
    setCurrentDoctors(currentDoctors.filter(d => d !== doctor));
    setAvailableDoctors([...availableDoctors, doctor]);
  }

  const handleAddDoctor = (doctor) => {   
    setAvailableDoctors(availableDoctors.filter(d => d !== doctor));
    setCurrentDoctors([...currentDoctors, doctor]);
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.keyCode === 27) {
        setModalActive(false);
      }
    }

    document.addEventListener('keydown', handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener('keydown', handleKeyDown);
    }
  }, []);

  if(
    insertDoctorToProcessRoleLoading ||
    loadingDoctorsData ||
    insertRoleAndDoctorToProcessRoleLoading
  ) 
    return(
      <S.ModalShareAccessToPatient>
        <div className="modal-background">
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaReaction
              widthimg={"150px"}
              zaiaImg={logoZaiaLoading}
              padding={"200px 0px"}
            />
          </div>
        </div>
      </S.ModalShareAccessToPatient>
    )

  if(formSuccess)
    return(
      <S.ModalShareAccessToPatient>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              button1Text={t("globally.done")}
              title={t("profile.invitationManagement.sharePatientDataSuccess")}
            />
          </div>
        </div>
      </S.ModalShareAccessToPatient>
    )

  if(formSuccess === false)
    return(
      <S.ModalShareAccessToPatient>
        <div className="modal-background" onClick={() => setModalActive(false)}>
        </div>
        <div className="modal-container">
          <div className="modal-container__reaction">
            <ZaiaModalResponseContent
              button1={() => setModalActive(null)}
              formSuccess={formSuccess}
              title={t("globally.errorForm")}
              subtitle={t("profile.invitationManagement.sharePatientDataError")}
              button1Text={t("globally.accept")}            
            />
          </div>
        </div>
      </S.ModalShareAccessToPatient>
    )

  return (
    <S.ModalShareAccessToPatient>
      <div className="modal-background" onClick={() => setModalActive(false)}>
      </div>
      <div className="modal-container">
        <div className="header">
          <div className="header__text">
            <div className="header__title">{t("profile.invitationManagement.sharePatiendDataTitle")}</div>
            <div className="header__patient">
              <ZaiaImage
                size={24}
                img={patientInfo.user.picture}
                rounded={true}
              />
              <div className="header__patient-name">{`${patientInfo.user.name} ${patientInfo.user.lastname}`}</div>
              <div className="header__patient-process">{P.dataTranslation(patientInfo?.process?.processName, language)}</div>
            </div>
          </div>
          <div className="header__action" onClick={() => setModalActive(false)}>
            <i className="header__action-icon icon zaia-icono-cerrar"/>
          </div>
        </div>
        <div className="modal-content">
          <div className="modal-content__left">
            <div className="devices-linked">
              <div className="devices-linked__title">
                <div className="title">
                  {t("aiNavigator.pathologies.patientPathologies")}
                </div>
              </div>
              <div className="devices-linked__list">
                { currentDoctors.length === 0 
                  && <div className="devices-linked__list-empty">
                    {t("profile.smartDevices.noDevicesAdded")}
                  </div>
                }
                { 
                  currentDoctors
                  .map((doctor, index) => {
                    return (   
                      <div
                        key={index}
                        onClick={() => {
                          handleRemoveDoctor(doctor);
                        }}
                      >
                        <DoctorItem
                          doctor={doctor}
                          added={true}
                        />
                      </div>
                    )
                  }
                  )
                }
              </div>
            </div>
          </div>
          <div className="modal-content__right">
            <div className="devices-available">
              <div className="devices-available__title">
                <div className="title">
                  {t("aiNavigator.pathologies.pathologiesList")}
                </div>
                <div className="searcher">
                  <FlorenzSearchInput
                    placeholder={t("globally.search")}
                    forWhiteBackgroud={true}
                    getText={(text) => setInputText(text)}
                    borderanimation={false}
                  />
                </div>
              </div>
              <div className="devices-available__list">
                { loadingPatientsData
                  ? <div className="devices-available__list-loading">
                      <ZaiaReaction
                        widthimg={"100px"}
                        zaiaImg={logoZaiaLoading}
                        padding={"100px 0px"}
                      />
                    </div>
                  : errorPatientsData
                    ? <div className="devices-available__list-error">
                        <ZaiaReaction
                          widthimg={"150px"}
                          zaiaImg={logoZaiaAlert}
                          padding={"100px 0px"}
                          text={t("aiNavigator.pathologies.errorLoadingPathologies")}
                        />
                      </div>
                    : availableDoctors.length === 0
                      ? <div className="devices-available__list-empty">
                          <ZaiaReaction
                            widthimg={"150px"}
                            zaiaImg={eventsCalendarEmpty}
                            padding={"100px 0px"}
                            text={t("aiNavigator.pathologies.noPathologiesAvailable")}
                          />
                        </div>
                      : availableDoctors?.map((doctor, index) => 
                        (
                          getFilterText(`${doctor.name}`)
                        ) &&
                        (
                          <div
                            key={index}
                            onClick={() => {
                              handleAddDoctor(doctor);
                            }} 
                          >
                            <DoctorItem
                              doctor={doctor}
                              added={false}
                            />  
                          </div>
                        )
                      )
                }
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="button-container">
            <FlorenzButton
              typeStyle={"secondaryWhite"}
              size="s"
              text={t("globally.cancel")}
              widthComplete={true}
              onClick={() => {
                setModalActive(false)
              }}
            />
          </div>
          <div className="button-container">
            <FlorenzButton
              disabled={
                doctorsToAdd.length === 0 && doctorsToRemove.length === 0
              }
              size="s"
              typeStyle={"success"}
              text={t("globally.save")}
              widthComplete={true}
              icon={
                (doctorsToAdd.length === 0 && doctorsToRemove.length === 0) && "zaia-i-lock-chat"
              }
              onClick={() => {
                handleSubmit()
              }}
            />
          </div>
        </div>
      </div>
    </S.ModalShareAccessToPatient>
  );
}


export default ModalShareAccessToPatient;
